import DeliveryTab from './DeliveryTab';
import { withI18n } from 'react-i18next';

export default withI18n()(DeliveryTab);
